import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, catchError, finalize, throwError } from 'rxjs';

import { AuthService, FeedMessageService, LoadingService, SigntrustService, UserPinSessionService, UtilsService } from '@services/index.service';
import { AngularPaths, CheckDomainRequest, Consumer, ErrorCode, MessageType, Response } from '@models/index.model';
import { TranslateService } from '@ngx-translate/core';

@Injectable({providedIn: 'root'})
export class UserPinGuard {
  public constructor(
    private _userPinSession: UserPinSessionService,
    private _router: Router,
    public _utils: UtilsService,
    private _loading: LoadingService,
    public _auth: AuthService,
    public translate: TranslateService,
    private _signtrustServ: SigntrustService,
    private _notify: FeedMessageService
    ) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this._userPinSession.checkTokenValid()) {
      return true;
    }

    if (state.url.includes(`/${AngularPaths.CONFIG_USER_PIN}/`)) {
      const cleanData = state.url.replace(`/${AngularPaths.CONFIG_USER_PIN}/`, '');
      console.log(cleanData);
      if (cleanData) {
        localStorage.setItem('userPinRedirectId', cleanData);
        return this._router.parseUrl(`${AngularPaths.USER_PIN}/${cleanData}`);
      }
    } else {
      this._userPinSession.removeBrowserSession();
    }
  }
}
